import { useState } from 'react'

export interface BankPaymentInformation {
  firstName: string
  lastName: string
  routingNumber: string
  bankAccountNumber: string
  confirmBankAccountNumber: string
}

export interface UseBankPaymentFormReturn {
  bankPaymentInformation: BankPaymentInformation
  setBankPaymentInformation: (
    info:
      | BankPaymentInformation
      | ((prev: BankPaymentInformation) => BankPaymentInformation)
  ) => void
  requiredPaymentInformationPresent: boolean
}

export const useBankPaymentForm = (): UseBankPaymentFormReturn => {
  const [bankPaymentInformation, setBankPaymentInformation] =
    useState<BankPaymentInformation>({
      firstName: '',
      lastName: '',
      routingNumber: '',
      bankAccountNumber: '',
      confirmBankAccountNumber: '',
    })

  const requiredPaymentInformationPresent =
    !!bankPaymentInformation.firstName &&
    !!bankPaymentInformation.lastName &&
    !!bankPaymentInformation.bankAccountNumber &&
    !!bankPaymentInformation.confirmBankAccountNumber &&
    !!bankPaymentInformation.routingNumber &&
    bankPaymentInformation.routingNumber.length === 9

  return {
    bankPaymentInformation,
    setBankPaymentInformation,
    requiredPaymentInformationPresent,
  }
}
